export const CTA_TEXT = {
    APPLY: "Apply selected coupons",
    GOT_IT: "Got it!",
};

export const SPARKLE_ICON = {
    ALT: "sparkle-icon",
    IMAGE_ID: "portal/static-assets/icons/gifting-cart/sparkle-filled.png",
    WIDTH: "12px",
    HEIGHT: "12px",
};
